/**
 * Register block styles.
 *
 * @package
 */

/**
 * WordPress dependencies.
 */
import { registerBlockStyle, unregisterBlockStyle } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import domReady from '@wordpress/dom-ready';

/**
 * Media Text Block styles.
 *
 * @type {Array}
 */
const layoutStyleMediaText = [
	{
		name: 'layout-home-media-text',
		label: __( 'Home media text', 'tcc' ),
	},
	{
		name: 'layout-media-text-shadow',
		label: __( 'Media with shadow and text', 'tcc' ),
	},
];

/**
 * Cover with art Block styles.
 *
 * @type {Array}
 */
const layoutStyleCover = [
	{
		name: 'layout-cover-art',
		label: __( 'Cover Art - Text Left Aligned', 'tcc' ),
	},
	{
		name: 'layout-cover-art-center',
		label: __( 'Cover Art - Text Center Aligned', 'tcc' ),
	},
	{
		name: 'layout-cover-hero',
		label: __( 'Cover Hero', 'tcc' ),
	},
	{
		name: 'layout-cover-hero-extra-padding',
		label: __( 'Cover Hero Extra Padding', 'tcc' ),
	},
];

/**
 * Group Block styles.
 *
 * @type {Array}
 */
const layoutStyleGroup = [
	{
		name: 'layout-home-group-media-text',
		label: __( 'Home media text', 'tcc' ),
	},
	{
		name: 'layout-group-list',
		label: __( 'List', 'tcc' ),
	},
	{
		name: 'layout-group-jumbo',
		label: __( 'Jumbo', 'tcc' ),
	},
	{
		name: 'layout-group-heading-text',
		label: __( 'Jumbo heading text', 'tcc' ),
	},
	{
		name: 'layout-group-media-text-art',
		label: __( 'Media text with art', 'tcc' ),
	},
	{
		name: 'layout-group-left-media-text',
		label: __( 'Media on left with text', 'tcc' ),
	},
];

/**
 * List Block styles.
 *
 * @type {Array}
 */
const layoutStyleList = [
	{
		name: 'layout-list-circle',
		label: __( 'List circle', 'tcc' ),
	},
	{
		name: 'layout-list-numbers',
		label: __( 'List numbers', 'tcc' ),
	},
];

/**
 * Button Block styles.
 *
 * @type {Array}
 */
const layoutStyleButton = [
	{
		name: 'layout-button-orange-background',
		label: __( 'Orange background', 'tcc' ),
	},
	{
		name: 'layout-button-link-arrow',
		label: __( 'Link with arrow', 'tcc' ),
	},
	{
		name: 'layout-button-link-arrow-black',
		label: __( 'Link with arrow black', 'tcc' ),
	},
];

/**
 * Deregister styles and blocks.
 *
 * @return {void}
 */
const deRegister = () => {
	
	// Unregister Block Styles.
	unregisterBlockStyle( 'core/pullquote', 'solid-color' );
	unregisterBlockStyle( 'core/button', 'outline' );
	unregisterBlockStyle( 'core/button', '3d' );
	unregisterBlockStyle( 'core/button', 'shadow' );
	unregisterBlockStyle( 'core/button', 'fill' );
	unregisterBlockStyle( 'core/list', 'default' );
};

/**
 * Register styles.
 *
 * @return {void}
 */
const register = () => {
	layoutStyleMediaText.forEach( ( layoutStyle ) =>
		registerBlockStyle( 'core/media-text', layoutStyle ),
	);
	
	layoutStyleGroup.forEach( ( layoutStyle ) =>
		registerBlockStyle( 'core/group', layoutStyle ),
	);
	
	layoutStyleList.forEach( ( layoutStyle ) =>
		registerBlockStyle( 'core/list', layoutStyle ),
	);
	
	layoutStyleCover.forEach( ( layoutStyle ) =>
		registerBlockStyle( 'core/cover', layoutStyle ),
	);
	
	layoutStyleButton.forEach( ( layoutStyle ) =>
		registerBlockStyle( 'core/button', layoutStyle ),
	);
};

/**
 * Register and unregister styles on dom ready.
 */
domReady( () => {
	deRegister();
	register();
} );
